import { Link as RemixLink } from "@remix-run/react";

import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverArrow,
  PopoverCloseButton,
  IconButton,
  Button,
  VStack,
  Text,
  Portal,
  Icon,
  useColorModeValue,
  Link,
} from "@chakra-ui/react";

// import { MdHelpOutline as HelpIcon } from "react-icons/md";
import { QuestionIcon as HelpIcon } from "@chakra-ui/icons";
import { useOptionalUser } from "#app/hooks/index.js";

export function HelpPopover({
  body,
  header,
  buttonText,
  label = buttonText,
  variant = "link",
  contentProps = {},
  ...rest
}) {
  const borderBottomColor = useColorModeValue("brand.500", "brand.200");

  const buttonVariantProps =
    variant === "link"
      ? {
          borderBottomWidth: "2px",
          borderBottomStyle: "dotted",
          borderBottomColor,
        }
      : {};

  return (
    <Popover preventOverflow={true} boundary="scrollParent">
      <PopoverTrigger>
        {buttonText ? (
          <Button
            variant={variant}
            color="inherit"
            fontWeight="inherit"
            borderRadius={0}
            // rightIcon={
            //   <Icon as={HelpIcon} fontSize="0.8rem" mt={-1} color="default" />
            // }
            // iconSpacing={1}
            aria-label={label}
            {...buttonVariantProps}
            {...rest}
          >
            {buttonText}
          </Button>
        ) : (
          <IconButton
            isRound
            variant="ghost"
            aria-label={label}
            p={0}
            size="xs"
            icon={<Icon as={HelpIcon} />}
            _hover={{
              bg: "buttonHover",
            }}
            _focus={{
              bg: "buttonFocus",
            }}
            _active={{
              bg: "buttonActive",
            }}
            {...rest}
          />
        )}
      </PopoverTrigger>
      <Portal>
        <PopoverContent {...contentProps}>
          <PopoverArrow />
          {header && <PopoverCloseButton />}
          {header && <PopoverHeader>{header}</PopoverHeader>}
          {body && <PopoverBody>{body}</PopoverBody>}
        </PopoverContent>
      </Portal>
    </Popover>
  );
}

export function UniqueNotificationHelpPopover({
  buttonText = "unique notifications",
  ...rest
}) {
  const user = useOptionalUser();

  return (
    <HelpPopover
      buttonText={buttonText}
      header="What's a unique notification?"
      body={
        <>
          <Text mb={4}>
            A <strong>unique notification</strong> contains new campsite
            availability that you haven't seen before.
          </Text>
          <Text mb={4}>
            If the same campsite becomes available a second time (usually when
            someone drops a reservation from their cart), we'll send a{" "}
            <strong>duplicate notification</strong> for free.
          </Text>
          <Text>
            We'll always notify you of duplicates, because they're a legit
            chance to book, but they don't count towards your usage.
          </Text>
          {user && (
            <Text mt={4}>
              You can see what notifications we consider unique on{" "}
              <Link as={RemixLink} to="/account">
                your account page
              </Link>
              .
            </Text>
          )}
        </>
      }
      {...rest}
    />
  );
}
